import { useSignupPageIdFromUrl } from 'modules/signup-page/hooks/useSignupPageIdFromUrl';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useNavbar } from 'shared/hooks/useNavbar';

import './styles.scss';

enum PreRegistrationUserType {
    STUDENT = 'STUDENT',
    PARENT = 'PARENT',
}

export const PublicSignup = () => {
    const {t} = useTranslation();
    useNavbar(true);

    // const [userType, setUserType] = React.useState<PreRegistrationUserType | undefined>();

    const navigate = useNavigate();
    const signupPageId = useSignupPageIdFromUrl();

    const onSubmit = (selectedType: PreRegistrationUserType) => {
        if (selectedType === PreRegistrationUserType.STUDENT) {
            navigate(`/join/public/student/${signupPageId}`);
        } else {
            navigate(`/join/public/parent/${signupPageId}`);
        }
    };

    return (
        <div className="pre-signup-page">
            <h1 className="page-title">Who Are You Signing Up As?</h1>
            <div className="card-container">
                <div className="signup-card">
                    {/* <img
                        src="https://via.placeholder.com/300x180?text=Student"
                        alt="Student"
                        className="card-image"
                    /> */}
                    <h2>I’m a Student</h2>
                    <p>Join the platform as a student and start learning today.</p>
                    <button onClick={() => onSubmit(PreRegistrationUserType.STUDENT)}>
                        Continue as Student
                    </button>
                </div>
                <div className="signup-card">
                    {/* <img
                        src="https://via.placeholder.com/300x180?text=Parent"
                        alt="Parent"
                        className="card-image"
                    /> */}
                    <h2>I’m a Parent</h2>
                    <p>Sign up to support your child’s learning journey.</p>
                    <button onClick={() => onSubmit(PreRegistrationUserType.PARENT)}>
                        Continue as Parent
                    </button>
                </div>
            </div>
        </div>
    );
};